import { PortalButton } from "./PortalPrimitives";

// Pie de diálogo con un único botón "Cerrar", alineado a la derecha: mismo
// bloque en `AdvancedFiltersModal` y `TemplatePreviewDialog`
// (`TemplatePreview.tsx`) — jscpd lo marcó como clon exacto (quality-gate,
// revisión de duplicación 2026-09-23).
export function ModalCloseFooter({
  onClose,
  label = "Cerrar",
}: {
  onClose: () => void;
  label?: string;
}) {
  return (
    <div style={{ display: "flex", justifyContent: "flex-end" }}>
      <PortalButton
        type="button"
        tone="secondary"
        size="small"
        onClick={onClose}
      >
        {label}
      </PortalButton>
    </div>
  );
}
